import { NavLink } from 'react-router-dom';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import { useState } from 'react';

export default function Stage02() {
  return (
    <div>
      <Navigation />

      {/* <Banner src='/img/stage-01.jpg' classType='banner__image--other-01' /> */}
      <Banner src='/img/thrulkhor-02.webp' classType='banner__image--top-02 banner--tiny' />

      <main className='stage01'>
        <NavLink to='/stages-et-retraites' className='retour'>
          <div className='retour__icon--down-arrow'>
            <img src='/icons/left-arrow.svg' alt='icone dun chevron' />
          </div>
          <p className='retour__text'>Retour à la liste</p>
        </NavLink>

        <h2 className='presentation__title heading-section color-black'>
          Thrulkhors de santé et corps conscient
        </h2>

        <p className='presentation__subtitle'>Harmonie du corps et de la conscience</p>

        <div className='infos u-margin-bottom-big'>
          <h3 className='infos__dates'>Du 22 au 24 Août 2025</h3>
          <div className='infos__duree-et-prix'>3 jours / 2 nuits 310€ (270€ jusqu au 15 Mars)</div>
          <div className='seance__bottom--localisation localisation stage__localisation'>
            <div className='localisation__logo'>
              <img
                src='/icons/location.svg '
                alt='logo de localisation'
                className='localisation__logo1'
              />
            </div>
            <div className='localisation__lieu'>Juvigny Val d&apos;Andaine</div>
          </div>
        </div>

        <section className='bienfaits u-margin-bottom-big'>
          <h3 className='heading-sous-titre u-margin-bottom-medium programme__sous-titre u-center-text'>
            Thrulkhors de santé et corps conscient
          </h3>

          <p className='common-text bienfaits__list--element u-justify-text'>
            Les thrulkhors de santé s&apos;avèrent être une aide précieuse pour toute personne dont
            le souhait est de réaliser ce que nous appelons, dans le bouddhisme, l'Eveil, mais
            également qui, pratiqués régulièrement sur le long terme, permettent de promouvoir, à
            travers la réalisation du corps conscient, un bon équilibre psychosomatique général. Les
            thrulkhors sont des exercices dans lesquels la respiration et la concentration de
            l&apos;esprit sont intégrés comme composantes essentielles en conjonction avec des
            mouvements particuliers du corps. Ces thrulkhors permettent la manipulation du corps
            subtil et conduisent à des expériences spirituelles et à la transformation du
            pratiquant. Le corps subtil ou « corps adamantin » est composé de canaux (tsa), de
            souffles vitaux (lung) et de gouttes vitales (tiglé). Les thrulkhors agissent sur ces
            trois aspects du « corps adamantin », mais ce sont plus particulièrement les canaux
            visualisés et les souffles dirigés par la respiration qui sont mobilisés. L&apos;esprit
            chevauche les souffles et les deux circulent à travers les canaux à l&apos;aide de
            mouvements spécifiques. Dans l&apos;incarnation humaine, l'esprit est en continuelle
            relation avec le corps ; et le domaine de rencontre entre le corps et l'esprit est le
            réseau de circulation des énergies subtiles, caractérisé par un ensemble de canaux qui
            confluent vers des centres, ou « roues », situés dans des régions spécifiques du corps.
            Notre état de santé - physique, émotionnel, mental et spirituel - dépend directement de
            la plus ou moins bonne circulation des énergies à travers ce réseau. Lorsque les
            énergies circulent harmonieusement, toutes les émotions conflictuelles sont pacifiées.
            Le fait de coordonner des mouvements spécifiques du corps avec l'attention vigilante de
            l'esprit devient donc une méthode puissante pour purifier tout ce réseau énergétique.
            Par une pratique continuelle, le corps et l'esprit se trouvant alors établis à la bonne
            place, la conscience - calme, claire et lumineuse -, qui est la nature fondamentale de
            l'esprit, apparaît tel le Soleil dans l'espace. Les différents cycles des exercices
            pourront permettre au pratiquant de réaliser un état de détente du corps et de
            l&apos;esprit favorisant le calme mental, l&apos;actualisation du corps conscient. Les
            éléments internes seront équilibrés, les conditions négatives seront pacifiées et les
            positives améliorées. En conséquence on obtiendra un mieux-être physique et mental. Les
            thrulkhors de santé sont une méthode simple et efficace ouverte vers toute voie
            d&apos;épanouissement du potentiel humain et de la pleine conscience.
          </p>
        </section>

        <section className='programme '>
          <h3 className='heading-sous-titre u-margin-bottom-medium programme__sous-titre u-center-text'>
            Modalités d'intervention
          </h3>

          <p className='common-text bienfaits__list--element u-justify-text color-black u-justify-text'>
            Afin d&apos;expérimenter les bienfaits générés par la pratique des thrulkhors de santé,
            l&apos;association ArkanHom propose des stages de week-end, au cours desquels
            progressivement chaque participant se familiarisera avec les mouvements et la
            respiration propres à cette technique. En outre, des séquences de relaxation
            faciliteront la détente favorable à la pratique de la méditation.
          </p>
        </section>

        <p className='common-text u-margin-bottom-big remarque my-special-common-text color-black'>
          *Les repas à tendances bio, végétariens et locaux et adaptés à la pratique sont compris
          dans le prix du stage.
        </p>

        {/* <iframe
          width='560'
          height='315'
          src='https://youtube.com/shorts/ZwDyG9jiLvI?si=j4TtpQF6fY4uQezW'
          title='YouTube video player'
          frameborder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          referrerpolicy='strict-origin-when-cross-origin'
          allowfullscreen
        ></iframe> */}
        {/* <iframe
          width='560'
          height='315'
          src='https://youtube.com/shorts/ZwDyG9jiLvI?si=wKmTHkSSngsEB8Pa'
          title='YouTube Shorts player'
          frameborder='0'
          allowfullscreen
        ></iframe> */}

        <section className='tarifs-et-inscription u-margin-bottom-big '>
          <h2 className='presentation__title programme__sous-titre heading-section u-center-text color-black u-margin-bottom-big'>
            Tarifs & inscriptions
          </h2>
          <div className='tarifs-et-inscription__container'>
            <div className='tarifs-et-inscription__element'>
              <div className='tarifs-et-inscription__element--head'>
                <h3 className='heading-sous-sous-titre'>Inscription classique</h3>
                <p className='tarifs-et-inscription__element--head-price'>310€</p>
              </div>

              <div className='tarifs-et-inscription__element--middle'>
                🛌 Chambre individuelle ou partagée
                <br />
                ☀️ Hébergement 3 jours
                <br />
                🍽️ Repas inclus (tendance végétarien, bio, local, adaptée à la pratique du yoga et
                de la méditation)
              </div>

              <NavLink
                to={
                  'https://www.helloasso.com/associations/arkanhom/evenements/inscription-stage-thrulkhors-de-sante-et-corps-conscient'
                }
                className='tarifs-et-inscription__element--bottom btn btn--white'
              >
                Inscrivez-vous !{' '}
              </NavLink>
            </div>

            <div className='tarifs-et-inscription__element'>
              <div className='tarifs-et-inscription__element--head'>
                <h3 className='heading-sous-sous-titre'>Early birds</h3>
                <p className='tarifs-et-inscription__element--head-price'>270€</p>
              </div>

              <div className='tarifs-et-inscription__element--middle'>
                🛌 Chambre individuelle ou partagée
                <br />
                ☀️ Hébergement 3 jours
                <br />
                🍽️ Repas inclus (tendance végétarien, bio, local, adaptée à la pratique du yoga et
                de la méditation)
              </div>

              <NavLink
                to={
                  'https://www.helloasso.com/associations/arkanhom/evenements/inscription-stage-thrulkhors-de-sante-et-corps-conscient'
                }
                className='tarifs-et-inscription__element--bottom btn btn--white'
              >
                Inscrivez-vous !{' '}
              </NavLink>
            </div>
          </div>
        </section>

        <section className='le-lieu u-margin-bottom-big'>
          <h2 className='presentation__title heading-section color-black u-margin-bottom-small formateur-000'>
            Le lieu
          </h2>
          <p className='common-text u-margin-bottom-medium'>
            Un lien emprunt d&apos;histoire, chaleureux et accueillant pour nos groupes.
          </p>

          <Caroussel photos_caroussel_srcs={photos_caroussel_srcs} />
        </section>

        <section className='banner-en-savoir-plus u-margin-bottom-big'>
          <p className='u-margin-bottom-medium banner-en-savoir-plus__text'>
            Envie d&apos;en savoir plus sur les disciplines proposées lors de cette retraite?
            <br /> Découvrez nos articles
          </p>
          <div className='banner-en-savoir-plus__container'>
            <NavLink to={'/articles/1'} className='btn-navlink'>
              Les Thrulkors{' '}
            </NavLink>
          </div>
        </section>

        <section className='formateur u-margin-bottom-big'>
          <h2 className='presentation__title heading-section formateur-000'>Votre formateur</h2>
          <div className='formateur__details'>
            <img
              src='/img/stage-06.webp'
              alt='Formateur Antoine'
              className='formateur__details--img'
            />
            <div className='formateur__details--infos'>
              <h3 className='formateur__details--infos-name'>Antoine</h3>
              <p className='formateur__details--infos-text'>
                Fondateur & Enseignant certifié à l&apos;enseignement du Yoga
              </p>
            </div>
            <NavLink className={'btn-navlink btn-formateur'} to={'/qui-sommes-nous'}>
              En savoir plus
            </NavLink>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

const photos_caroussel_srcs = [
  '/img/image-arkanhom-02.jpg',
  '/img/image-arkanhom-01.jpg',
  '/img/image-110.jpg',
  '/img/chandra-02.jpg',
];

function Bulle(props) {
  return (
    <div className={`bulle ${props.index === props.step ? 'bulle-active' : 'not-active'}`}></div>
  );
}

function Caroussel({ photos_caroussel_srcs }) {
  const [previousStep, setPreviousStep] = useState(0);
  const [step, setStep] = useState(1);
  const [nextStep, setNextStep] = useState(2);

  function handlePrevious(step) {
    setPreviousStep(previousStep === 0 ? photos_caroussel_srcs.length - 1 : previousStep - 1);
    setStep(step === 0 ? photos_caroussel_srcs.length - 1 : step - 1);
    setNextStep(nextStep === 0 ? photos_caroussel_srcs.length - 1 : nextStep - 1);
  }

  function handleNext(step) {
    setPreviousStep(previousStep === photos_caroussel_srcs.length - 1 ? 0 : previousStep + 1);
    setStep(step === photos_caroussel_srcs.length - 1 ? 0 : step + 1);
    setNextStep(nextStep === photos_caroussel_srcs.length - 1 ? 0 : nextStep + 1);
  }

  return (
    <div className='caroussel__container'>
      <div className='caroussel__images'>
        <img
          src='/icons/left-arrow.svg'
          alt=''
          className='caroussel__arrow--left'
          onClick={() => handlePrevious(step)}
        />
        <img
          src='/icons/left-arrow.svg'
          alt=''
          className='caroussel__arrow--right'
          onClick={() => handleNext(step)}
        />
        <img
          src={photos_caroussel_srcs[previousStep]}
          alt=''
          className='caroussel__images--image-1 caroussel__images--image'
        />
        <img
          src={photos_caroussel_srcs[step]}
          alt=''
          className='caroussel__images--image-2 caroussel__images--image'
        />
        <img
          src={photos_caroussel_srcs[nextStep]}
          alt=''
          className='caroussel__images--image-3 caroussel__images--image'
        />
      </div>
      <div className='caroussel__bubulle'>
        {photos_caroussel_srcs.map((src, index) => (
          <Bulle src={src} index={index} key={index} step={step} />
        ))}
      </div>
    </div>
  );
}
